import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  ContainerDivs,
  Header,
  HeaderTop,
  HeaderInfo,
  Title,
  Subtitle,
  HeaderStats,
  StatPill,
  YearProgress,
  InfoBanner,
  SectionLabel,
  Timeline,
  TimelineItem,
  TimelineDot,
  PeriodCard,
  PeriodHeader,
  PeriodTitle,
  StatusChip,
  Badge,
  PeriodBody,
  DateField,
  GradeField,
  PeriodFooter,
  EmptyPeriod,
  ViewDaysButton,
  EditButton,
  DefineButton,
  SkeletonCard,
  SkeletonLine,
  ErrorState,
  RetryButton,
  Overlay,
  Modal,
  ModalTitle,
  ModalText,
  ModalActions,
  ConfirmButton,
  CancelButton,
  CalendarModal,
  CalendarModalHeader,
  CalendarLegend,
  CalendarScroll,
  MonthBlock,
  MonthName,
  WeekHeader,
  DaysGrid,
  DayCell,
  CalendarFooter,
  CloseButton,
  EmptyCalendar,
} from './style';

import {
  getSchoolYear,
  getIstQuarter,
  getIIndQuarter,
  getIIIrdQuarter,
  getIVthQuarter,
  getAssessmentRegime,
  getSchoolDays,
  getRecoveryConfig,
} from '../../Api';

import { useNavigate } from 'react-router-dom';
import { TIPOS_DIA, TIPOS_NAO_LETIVOS, contarNaoLetivos, mapaNaoLetivos, chaveUTC } from '../../components/NonSchoolDays';

const MONTH_NAMES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];
const WEEK_DAYS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

const pad = (n) => String(n).padStart(2, '0');
const todayStr = () => new Date().toISOString().split('T')[0];

// monta Date a partir dos campos do período (00:00 local)
const buildDate = (y, m, d) => new Date(y, (m || 1) - 1, d || 1);

// status do período em relação à data atual
const periodStatus = (res) => {
  if (!res) return 'empty';
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const start = buildDate(res.startyear, res.startmonth, res.startday);
  const end = buildDate(res.endyear, res.endmonth, res.endday);
  end.setHours(23, 59, 59, 999);
  if (now < start) return 'future';
  if (now > end) return 'done';
  return 'active';
};

const STATUS_TEXT = {
  active: '● Em andamento',
  done: '✓ Concluído',
  future: '○ A iniciar',
};

const HomeSchool = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  const [anoLetivo, setanoLetivo] = useState('');
  const [recuperacaoCfg, setRecuperacaoCfg] = useState(undefined); // undefined = carregando, null = não configurada
  const [assessmentFormat, setassessmentFormat] = useState('');
  const [assessmentRegime, setAssessmentRegime] = useState('');
  const [regime, setRegime] = useState('');
  const [IStQuarter, setIStQuarter] = useState([]);
  const [IIndQuarter, setIIndQuarter] = useState([]);
  const [IIIrdQuarter, setIIIrdQuarter] = useState([]);
  const [IVthQuarter, setIVthQuarter] = useState([]);
  const [position_at_school, setPosition_at_school] = useState('');
  const [positionAtEducationDepartment, setPositionAtEducationDepartment] = useState('');
  const [schoolDays, setSchoolDays] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [pendingNavigate, setPendingNavigate] = useState(null);

  const [showSchoolDaysModal, setShowSchoolDaysModal] = useState(false);
  const [selectedSchoolDays, setSelectedSchoolDays] = useState([]);
  const [selectedPeriodTitle, setSelectedPeriodTitle] = useState('');
  const [selectedNonSchoolDays, setSelectedNonSchoolDays] = useState([]);

  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;

    (async () => {
      setLoading(true);
      setError(false);
      try {
        const idSchool = sessionStorage.getItem('id-school');
        const parsedId = JSON.parse(idSchool);

        const schoolYear = await getSchoolYear(parsedId);
        const year = schoolYear.data.data;

        const [schoolDaysRes, regimeRes, q1, q2, q3, q4] = await Promise.all([
          getSchoolDays(parsedId, year),
          getAssessmentRegime(parsedId),
          getIstQuarter(year, parsedId),
          getIIndQuarter(year, parsedId),
          getIIIrdQuarter(year, parsedId),
          getIVthQuarter(year, parsedId),
        ]);

        if (!mountedRef.current) return;

        setanoLetivo(year);
        if (schoolDaysRes?.data) setSchoolDays(schoolDaysRes.data.schoolDays || []);

        setassessmentFormat(sessionStorage.getItem('assessmentFormat'));
        setPosition_at_school(localStorage.getItem('position_at_school'));

        if (regimeRes?.data?.data) {
          setAssessmentRegime(regimeRes.data.data);
          sessionStorage.setItem('assessmentRegime', regimeRes.data.data);
        }

        setIStQuarter(q1?.data?.data || []);
        setIIndQuarter(q2?.data?.data || []);
        setIIIrdQuarter(q3?.data?.data || []);
        setIVthQuarter(q4?.data?.data || []);

        setRegime(q1?.data?.data?.[0]?.assessmentRegime || '');
        setPositionAtEducationDepartment(localStorage.getItem('positionAtEducationDepartment'));
      } catch (err) {
        console.error('Erro ao carregar período avaliativo:', err);
        if (mountedRef.current) setError(true);
      } finally {
        if (mountedRef.current) setLoading(false);
      }
    })();

    return () => { mountedRef.current = false; };
  }, [reloadKey]);

  // situação da configuração da recuperação (só para a escola mostrar o aviso)
  useEffect(() => {
    if (!anoLetivo) return;
    let ativo = true;
    (async () => {
      try {
        const id = JSON.parse(sessionStorage.getItem('id-school') || 'null');
        const r = await getRecoveryConfig(id, anoLetivo);
        if (ativo) setRecuperacaoCfg(r?.data?.config || null);
      } catch { /* sem aviso se falhar */ }
    })();
    return () => { ativo = false; };
  }, [anoLetivo]);

  const canManage =
    !!positionAtEducationDepartment ||
    position_at_school === 'DIRETOR/SUPERVISOR' ||
    position_at_school === 'SECRETARIO';

  const periodLabel =
    regime === 'TRIMESTRAL' ? 'Trimestre'
      : regime === 'BIMESTRAL' ? 'Bimestre'
        : '';

  // ── progresso do ano letivo (do início do 1º ao fim do último período) ──
  const computeYearProgress = () => {
    const first = IStQuarter[0];
    const lastArr = regime === 'BIMESTRAL' ? IVthQuarter : IIIrdQuarter;
    const last = lastArr[0];
    if (!first || !last) return null;

    const start = buildDate(first.startyear, first.startmonth, first.startday);
    const end = buildDate(last.endyear, last.endmonth, last.endday);
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    const total = end - start;
    if (total <= 0) return null;
    const elapsed = now - start;
    const pct = Math.round((elapsed / total) * 100);
    return { pct, start, end };
  };
  const progress = computeYearProgress();

  // ── Edição ───────────────────────────────────────────────────
  const handleEditClick = (quarter, id, route) => {
    setPendingNavigate({ quarter, id, route });
    setShowModal(true);
  };
  const handleConfirmEdit = () => {
    if (pendingNavigate) {
      sessionStorage.setItem(pendingNavigate.quarter, pendingNavigate.id);
      navigate(pendingNavigate.route);
      setShowModal(false);
      setPendingNavigate(null);
    }
  };
  const handleCancelEdit = () => {
    setShowModal(false);
    setPendingNavigate(null);
  };

  // ── Dias letivos ─────────────────────────────────────────────
  const handleViewSchoolDays = (days, title, nonDays) => {
    setSelectedSchoolDays(days || []);
    setSelectedNonSchoolDays(nonDays || []);
    setSelectedPeriodTitle(title);
    setShowSchoolDaysModal(true);
  };
  const handleCloseSchoolDaysModal = () => {
    setShowSchoolDaysModal(false);
    setSelectedSchoolDays([]);
    setSelectedNonSchoolDays([]);
    setSelectedPeriodTitle('');
  };

  const renderCalendarMonths = () => {
    const temDias = (selectedSchoolDays?.length || 0) + (selectedNonSchoolDays?.length || 0) > 0;
    if (!temDias) return null;

    // datas lidas em UTC (salvas como meia-noite UTC) para não recuar um dia no fuso do Brasil
    const schoolDates = new Set(selectedSchoolDays.map((d) => chaveUTC(d.date)).filter(Boolean));
    const naoLetivos = mapaNaoLetivos(selectedNonSchoolDays);
    const today = todayStr();

    // meses que aparecem: os que têm dia letivo OU feriado/recesso/outro
    const months = {};
    const addMonth = (value, letivo) => {
      const k = chaveUTC(value);
      if (!k) return;
      const [y, m] = k.split('-').map(Number);
      const key = `${y}-${m - 1}`;
      if (!months[key]) months[key] = { year: y, month: m - 1, count: 0 };
      if (letivo) months[key].count += 1;
    };
    selectedSchoolDays.forEach((d) => addMonth(d.date, true));
    selectedNonSchoolDays.forEach((d) => addMonth(d.date, false));

    // ordena cronologicamente (corrige Dez antes de Out)
    const orderedMonths = Object.values(months).sort(
      (a, b) => a.year - b.year || a.month - b.month
    );

    return orderedMonths.map(({ year, month, count }) => {
      const firstDay = new Date(year, month, 1).getDay();
      const daysInMonth = new Date(year, month + 1, 0).getDate();

      const cells = [];
      for (let i = 0; i < firstDay; i++) cells.push(<DayCell key={`e-${i}`} $empty />);
      for (let d = 1; d <= daysInMonth; d++) {
        const dateStr = `${year}-${pad(month + 1)}-${pad(d)}`;
        const mark = naoLetivos.get(dateStr);
        const tipo = mark ? TIPOS_DIA[mark.type] : null;
        cells.push(
          <DayCell
            key={d}
            $school={schoolDates.has(dateStr)}
            $today={dateStr === today}
            title={tipo ? `${tipo.label}${mark.description ? `: ${mark.description}` : ''}` : undefined}
            style={{
              animationDelay: `${d * 0.012}s`,
              ...(tipo ? { background: tipo.cor, color: '#fff', fontWeight: 700, cursor: 'help' } : {}),
            }}
          >
            {d}
          </DayCell>
        );
      }

      return (
        <MonthBlock key={`${year}-${month}`}>
          <MonthName>
            <span>{MONTH_NAMES[month]} {year}</span>
            <span className="pill">{count} {count === 1 ? 'dia letivo' : 'dias letivos'}</span>
          </MonthName>
          <WeekHeader>
            {WEEK_DAYS.map((wd) => <span key={wd}>{wd}</span>)}
          </WeekHeader>
          <DaysGrid>{cells}</DaysGrid>
        </MonthBlock>
      );
    });
  };

  // ── Card de período ──────────────────────────────────────────
  const QuarterSection = ({ title, data, onEdit, onCreate }) => {
    const has = data.length > 0;
    const res = has ? data[0] : null;
    const status = has ? periodStatus(res) : 'empty';

    return (
      <TimelineItem>
        <TimelineDot $status={status} />
        <PeriodCard $status={status}>
          <PeriodHeader $empty={!has}>
            <PeriodTitle>
              {title}
              {has && STATUS_TEXT[status] && (
                <StatusChip $status={status}>{STATUS_TEXT[status]}</StatusChip>
              )}
            </PeriodTitle>
            {has && canManage && <EditButton onClick={onEdit}>✏️ Editar</EditButton>}
            {!has && canManage && <DefineButton onClick={onCreate}>＋ Definir Período</DefineButton>}
          </PeriodHeader>

          {has ? (
            <>
              <PeriodBody>
                <DateField>
                  <label>▸ Início</label>
                  <strong>{pad(res.startday)}/{pad(res.startmonth)}/{res.startyear}</strong>
                </DateField>
                <DateField>
                  <label>▸ Término</label>
                  <strong>{pad(res.endday)}/{pad(res.endmonth)}/{res.endyear}</strong>
                </DateField>
                {assessmentFormat === 'grade' && (
                  <>
                    <GradeField>
                      <label>Nota Total</label>
                      <strong>{String(res.totalGrade)}</strong>
                    </GradeField>
                    <GradeField $variant="media">
                      <label>Nota Média</label>
                      <strong>{String(res.averageGrade)}</strong>
                    </GradeField>
                  </>
                )}
              </PeriodBody>
              {(() => {
                const c = contarNaoLetivos(res.nonSchoolDays);
                // só mostra o que existe (contagem zero não aparece)
                const itens = [
                  { id: 'letivo', n: res.schoolDays?.length || 0 },
                  ...TIPOS_NAO_LETIVOS.map((id) => ({ id, n: c[id] })),
                ].filter((i) => i.n > 0);
                if (itens.length === 0) return null;
                return (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, padding: '0 18px 12px' }}>
                    {itens.map(({ id, n }) => (
                      <span
                        key={id}
                        style={{
                          display: 'inline-flex', alignItems: 'center', gap: 6,
                          padding: '4px 10px', borderRadius: 999, fontSize: 12, fontWeight: 700,
                          background: `${TIPOS_DIA[id].cor}1f`, color: TIPOS_DIA[id].borda,
                          border: `1px solid ${TIPOS_DIA[id].cor}55`,
                        }}
                      >
                        <i style={{ width: 8, height: 8, borderRadius: '50%', background: TIPOS_DIA[id].cor, display: 'inline-block' }} />
                        {n} {n === 1 ? TIPOS_DIA[id].label.toLowerCase() : TIPOS_DIA[id].plural.toLowerCase()}
                      </span>
                    ))}
                  </div>
                );
              })()}
              <PeriodFooter>
                <ViewDaysButton onClick={() => handleViewSchoolDays(res.schoolDays, title, res.nonSchoolDays)}>
                  📅 Ver calendário
                  {res.schoolDays?.length ? <Badge>{res.schoolDays.length}</Badge> : null}
                </ViewDaysButton>
              </PeriodFooter>
            </>
          ) : (
            <EmptyPeriod>
              <span className="em">📭</span>
              Período ainda não definido
            </EmptyPeriod>
          )}
        </PeriodCard>
      </TimelineItem>
    );
  };

  // ── Skeleton ─────────────────────────────────────────────────
  if (loading) {
    return (
      <Container>
        <ContainerDivs>
          <Header>
            <HeaderTop>
              <HeaderInfo>
                <Title>Período Avaliativo</Title>
                <Subtitle>Carregando calendário…</Subtitle>
              </HeaderInfo>
            </HeaderTop>
          </Header>
          {[1, 2, 3].map((i) => (
            <SkeletonCard key={i}>
              <SkeletonLine $w="40%" $h="18px" />
              <SkeletonLine $w="70%" />
              <SkeletonLine $w="55%" />
            </SkeletonCard>
          ))}
        </ContainerDivs>
      </Container>
    );
  }

  // ── Erro ─────────────────────────────────────────────────────
  if (error) {
    return (
      <Container>
        <ContainerDivs>
          <ErrorState>
            <span className="icon">⚠️</span>
            <h2>Não foi possível carregar o período avaliativo</h2>
            <p>Verifique sua conexão e tente novamente.</p>
            <RetryButton onClick={() => setReloadKey((k) => k + 1)}>
              Tentar novamente
            </RetryButton>
          </ErrorState>
        </ContainerDivs>
      </Container>
    );
  }

  return (
    <Container>
      <ContainerDivs>
        {/* Cabeçalho */}
        <Header>
          <HeaderTop>
            <HeaderInfo>
              <Title>📊 Período Avaliativo</Title>
              <Subtitle>Calendário e períodos do ano letivo</Subtitle>
            </HeaderInfo>
            <HeaderStats>
              <StatPill>
                <strong>{anoLetivo}</strong>
                <span>Ano Letivo</span>
              </StatPill>
              <StatPill>
                <strong>{schoolDays.length}</strong>
                <span>Dias Letivos</span>
              </StatPill>
            </HeaderStats>
          </HeaderTop>

          {progress && progress.pct >= 0 && progress.pct <= 100 && (
            <YearProgress $pct={progress.pct}>
              <div className="labels">
                <span>Progresso do ano letivo</span>
                <span>{progress.pct}%</span>
              </div>
              <div className="track">
                <div className="fill" />
              </div>
            </YearProgress>
          )}
        </Header>

        {/* Recuperação: aviso para configurar (direção/secretaria, escolas com nota) */}
        {assessmentFormat === 'grade' && ['DIRETOR/SUPERVISOR', 'SECRETARIO'].includes(position_at_school) && recuperacaoCfg !== undefined && (
          recuperacaoCfg === null ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', background: 'var(--orange-soft, #fff1e0)', border: '1px solid var(--orange, #e67e22)', borderRadius: 12, padding: '12px 14px', margin: '0 0 12px' }}>
              <span style={{ flex: 1, minWidth: 200 }}>⚠️ A recuperação de {anoLetivo} ainda não foi configurada.</span>
              <button type="button" onClick={() => navigate('/recovery-config')} style={{ padding: '9px 16px', borderRadius: 9, border: 'none', background: 'var(--orange, #e67e22)', color: '#fff', fontWeight: 800, cursor: 'pointer' }}>
                Configurar recuperação
              </button>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', margin: '0 0 12px', fontSize: 14 }}>
              <span>🔁 Recuperação {recuperacaoCfg?.paralela?.ativa === false ? 'desativada' : 'configurada'}.</span>
              <button type="button" onClick={() => navigate('/recovery-config')} style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid var(--line, #d0d7db)', background: 'transparent', color: 'var(--text, #16323b)', fontWeight: 700, cursor: 'pointer' }}>
                Alterar
              </button>
            </div>
          )
        )}

        {/* Regime */}
        <InfoBanner>
          <h2>⚙️ Regime de Avaliação: {assessmentRegime}</h2>
          <span>
            Para alterar o regime, o <strong>Diretor</strong> ou{' '}
            <strong>Supervisor</strong> deve acessar{' '}
            <strong>Configurações → Regime de Avaliação</strong>, selecionar o novo
            regime e salvar. Caso você não tenha esse perfil, solicite a
            alteração a um responsável.
          </span>
        </InfoBanner>

        <SectionLabel>Períodos</SectionLabel>

        {/* Timeline de períodos */}
        <Timeline>
          <QuarterSection
            title={`1º ${periodLabel}`}
            data={IStQuarter}
            onEdit={() => handleEditClick('IstQuarterInformation', IStQuarter[0]?._id, '/updatei-stquarter')}
            onCreate={() => navigate('/createi-stquarter')}
          />
          <QuarterSection
            title={`2º ${periodLabel}`}
            data={IIndQuarter}
            onEdit={() => handleEditClick('IIndQuarterInformation', IIndQuarter[0]?._id, '/updateii-ndquarter')}
            onCreate={() => navigate('/createii-ndquarter')}
          />
          <QuarterSection
            title={`3º ${periodLabel}`}
            data={IIIrdQuarter}
            onEdit={() => handleEditClick('IIIrdQuarterInformation', IIIrdQuarter[0]?._id, '/updateiii-rdquarter')}
            onCreate={() => navigate('/createiii-rdquarter')}
          />
          {regime === 'BIMESTRAL' && (
            <QuarterSection
              title="4º Bimestre"
              data={IVthQuarter}
              onEdit={() => handleEditClick('IVthQuarterInformation', IVthQuarter[0]?._id, '/updateiv-thquarter')}
              onCreate={() => navigate('/createiv-thquarter')}
            />
          )}
        </Timeline>

        {/* Modal de aviso de edição */}
        {showModal && (
          <Overlay onClick={handleCancelEdit}>
            <Modal onClick={(e) => e.stopPropagation()}>
              <ModalTitle>⚠️ Atenção!</ModalTitle>
              <ModalText>
                Ao alterar as datas deste período,{' '}
                <strong>os diários já fechados não serão atualizados
                automaticamente</strong>. Para atualizar um diário fechado,
                altere as datas, reabra o diário e feche novamente para aplicar
                as novas configurações.
              </ModalText>
              <ModalActions>
                <CancelButton onClick={handleCancelEdit}>Cancelar</CancelButton>
                <ConfirmButton onClick={handleConfirmEdit}>Entendi</ConfirmButton>
              </ModalActions>
            </Modal>
          </Overlay>
        )}

        {/* Modal de dias letivos */}
        {showSchoolDaysModal && (
          <Overlay onClick={handleCloseSchoolDaysModal}>
            <CalendarModal onClick={(e) => e.stopPropagation()}>
              <CalendarModalHeader>
                <h3>📅 Calendário — {selectedPeriodTitle}</h3>
                <span className="count">{selectedSchoolDays.length} dias letivos</span>
              </CalendarModalHeader>

              {(selectedSchoolDays.length > 0 || selectedNonSchoolDays.length > 0) && (
                <CalendarLegend>
                  <span><i className="school" /> Dia letivo</span>
                  {TIPOS_NAO_LETIVOS.map((id) => (
                    <span key={id}>
                      <i style={{ background: TIPOS_DIA[id].cor }} /> {TIPOS_DIA[id].label}
                      {' '}({contarNaoLetivos(selectedNonSchoolDays)[id]})
                    </span>
                  ))}
                  <span><i className="off" /> Sem aula</span>
                  <span><i className="today" /> Hoje</span>
                </CalendarLegend>
              )}

              <CalendarScroll>
                {selectedSchoolDays.length === 0 && selectedNonSchoolDays.length === 0 ? (
                  <EmptyCalendar>Nenhum dia cadastrado no calendário.</EmptyCalendar>
                ) : (
                  renderCalendarMonths()
                )}
              </CalendarScroll>

              <CalendarFooter>
                <CloseButton onClick={handleCloseSchoolDaysModal}>Fechar</CloseButton>
              </CalendarFooter>
            </CalendarModal>
          </Overlay>
        )}
      </ContainerDivs>
    </Container>
  );
};

export default HomeSchool;
